import React, { useState, useEffect } from "react";
import { descriptionStates } from "../utils/constants";
import Description from "./Description";

import { IeHotspotControllerInterface } from "../types/IeHotspotControllerInterface";
import { DataInterface } from "../types/DataInterface";

// constants
const IMG_BASE_PATH = "./assets/images";

const IeHotspotController = ({ hotspotData }: IeHotspotControllerInterface) => {
  // state for selected img index
  const [requestedIndex, setRequestedIndex] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [descriptionState, setDescriptionState] = useState(
    descriptionStates.SHOW
  );

  useEffect(() => {
    if (requestedIndex !== selectedIndex) {
      setDescriptionState(descriptionStates.HIDE);
      setTimeout(() => {
        setSelectedIndex(requestedIndex);
        setDescriptionState(descriptionStates.SHOW);
      }, 1200);
    }
  }, [requestedIndex]);

  return (
    <>
      <div className="media">
        {hotspotData.map((item: DataInterface, index: number) => (
          <div
            className={`media-container image ${
              selectedIndex === index ? "image-show" : ""
            }`}
            key={item.key}
          >
            <img
              src={`${IMG_BASE_PATH}/${item.key}.jpg`}
              alt={`Chevy Silverado engine - ${item.key}`}
            />
          </div>
        ))}
      </div>
      <Description
        data={hotspotData}
        state={descriptionState}
        selectedIndex={selectedIndex}
      />
      <div className="navigation">
        <div className="nav-wrapper">
          <ul className="items-container">
            {hotspotData.map((hotspot: DataInterface, index: number) => (
              <>
                <button
                  className={`item stat-button-link ${
                    index === selectedIndex ? "selected" : ""
                  }`}
                  key={hotspot.key}
                  name="diesel engine features"
                  onClick={() => setRequestedIndex(index)}
                >
                  <div className="circle-container">
                    <div className="circle" />
                  </div>
                  <div className="label-container">
                    <span className="label" >
                      {hotspot.nav}
                    </span>
                  </div>
                </button>
                {index !== hotspotData.length - 1 && (
                  <div className="spacer">
                    <div className="bar" />
                  </div>
                )}
              </>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default IeHotspotController;
